import React from 'react'





const Blog = () => {
    
    return (
        <div className='mt-6 px-6'>
           
            <div className="grid lg:grid-cols-3 sm:grid-cols-2 md:grid-cols-2 border">

                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2  hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-brakes.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="	https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-glowplug.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="	https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-glowplug.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
              
                <div className="grid justify-center border  ">
                    <div className="p-5 ">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-car-care.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>

                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2  hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-brakes.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="	https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-glowplug.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-filters.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border  ">
                    <div className="p-5 ">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-car-care.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>

                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                <div className="grid justify-center border">
                    <div className="p-5">
                        <div className='border rounded-xl p-2 hover:bg-primary'>
                            <img className='w-full h-[300px]' src="https://k4j3j2s7.rocketcdn.me/partdo/wp-content/uploads/2022/10/category-electrics.png" alt="" />

                        </div>
                        <div className="mt-2 hover:text-[#F73775]">
                            <h1 className="text-center font-bold">Auto Safety & Security</h1>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa repellendus earum aliquam commodi nemo ipsum consequuntur cumque soluta magni! Sequi, obcaecati sit. Animi nulla odio, blanditiis possimus nobis est, quasi dolorum voluptatibus officia quia vel ratione quidem ab recusandae necessitatibus.</p>


                        </div>
                    </div>
                </div>
                


          </div>





        </div>
    );
};

export default Blog;